import { Component, OnDestroy, OnInit } from "@angular/core";
import { AuthService } from "../../../services/auth.service";
import { Router } from "@angular/router";
import {
  fadeInLeftOnEnterAnimation,
  fadeInOnEnterAnimation,
  fadeInUpBigOnEnterAnimation,
  fadeOutOnLeaveAnimation,
  fadeOutRightOnLeaveAnimation,
  headShakeAnimation,
} from "angular-animations";
import { UserService } from "../../../services/user.service";
import { Subscription } from "rxjs";
import { EventsService } from "../../../services/events.service";
import { environment } from "../../../../environments/environment";
import { AnalyticsService } from "../../../services/analytics.service";
import { CoachService } from "../service/coach.service";
import { CoachSessionModel } from "../models/session.model";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import {AlertController, Platform} from '@ionic/angular';
import { TranslateService } from "@ngx-translate/core";
import { NavService } from "src/app/services/nav.service";
import {ToastService} from '../../../services/toast.service';

@Component({
  selector: "app-coach-appointments-page",
  templateUrl: "coach-appointments.page.html",
  styleUrls: ["coach-appointments.page.scss"],
  animations: [
    fadeInOnEnterAnimation({ anchor: "enter", duration: 500 }),
    fadeOutOnLeaveAnimation({ anchor: "leave", duration: 500 }),
    fadeOutRightOnLeaveAnimation({ anchor: "leaveList", duration: 300 }),
    fadeInLeftOnEnterAnimation({ anchor: "enterList", duration: 300 }),
    fadeInUpBigOnEnterAnimation({ anchor: "enterUp", duration: 300 }),
    headShakeAnimation(),
  ],
})
export class CoachAppointmentsPage implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];

  environment = null;
  profileModel: CoachSessionModel = null;
  appointmentsList: CoachSessionModel[] = null;
  appointmentsListPromise: Promise<CoachSessionModel[]> = null;
  appointmentsListValid = true;
  profileForm: FormGroup = null;
  currentSession = null;
  currentNote = null;
  modalIsVisible = false;
  sessionId = null;
  public animationState = false;
  platform = 'website';
  availableTypes = [{code: 'video', title: '__CALENDAR_MEETING_TYPE_VIDEO__'},
        {code: 'face2face', title: '__CALENDAR_MEETING_TYPE_FACE2FACE__'}];
  hasCoachPhotos: boolean = false;

  constructor(
    private event: EventsService,
    public authService: AuthService,
    public userService: UserService,
    private analytics: AnalyticsService,
    private translate: TranslateService,
    private alertController: AlertController,
    private toast: ToastService,
    private coachService: CoachService,
    private router: Router,
    private nav: NavService,
    private platformService: Platform,
  ) {
    this.environment = environment;
    this.platform = this.authService.appMobile ? 'mobile' : 'website';

    this.subscriptions.push(
      this.event.subscribe("login", () => {
        this.appointmentsListValid = false;
      })
    );
    this.subscriptions.push(
      this.event.subscribe("logout", () => (this.appointmentsListValid = false))
    );
  }

  ngOnInit(): void {
    this.initForm();
  }

  ionViewWillEnter() {
    if (this.appointmentsList === null || !this.appointmentsListValid) {
      this.appointmentsListPromise =
        this.coachService.getMyCoachAppointmentsList();
    }
  }

  ionViewDidEnter() {
    this.analytics.trackView("Your Coaching Appointments");

    if (this.appointmentsList === null || !this.appointmentsListValid) {
      this.appointmentsListPromise.then((data) => {
        this.appointmentsList = data;
          this.appointmentsList.forEach(item => {
              if (item.coach.coach_type === 'coach') {
                  this.hasCoachPhotos = true;
              }
          })

        this.appointmentsListValid = true;
      });
    }
  }
  modalClose() {
    this.modalIsVisible = false;
    this.currentSession = null;
    this.currentNote = null;
  }
  cancelAppointment(session) {
    this.currentSession = session;
    this.initForm();
    this.modalIsVisible = true;
  }
  viewNote(note) {
    this.currentNote = note;
    this.modalIsVisible = true;
  }

  initForm() {
    this.profileForm = new FormGroup({
      reason: new FormControl("", Validators.required),
    });
  }

  onSubmit() {
    if (this.profileForm.status !== "VALID") {
      this.animateInvalidFields();
      this.alertController
        .create({
          header: this.translate.instant("__ALERT_ERROR_TITLE__"),
          message: this.translate.instant(
            "__ALERT_ERROR_MESSAGE_REQUIRED_FIELDS__"
          ),
          buttons: [this.translate.instant("__ALERT_ERROR_BUTTON__")],
        })
        .then((a) => a.present());
    } else {
      this.coachService
        .cancelCoachAppointment(
          this.currentSession.id,
          this.profileForm.value.reason
        )
        .then((data) => {
          if (data.hasOwnProperty("status") && data.status === "ok") {
            this.currentSession.reason = this.profileForm.value.reason;
            this.currentSession.status = "cancelled";
            this.modalIsVisible = false;

            this.toast.create('success', '__TOAST_APPOINTMENT_CANCELLED__');
            this.event.publish('coach:updateSessionStatus', this.currentSession);
          } else {
            this.alertController
              .create({
                header: this.translate.instant("__ALERT_ERROR_TITLE__"),
                message: this.translate.instant("__ALERT_SOME_WRONG__"),
                buttons: [this.translate.instant("__ALERT_ERROR_BUTTON__")],
              })
              .then((a) => a.present());
          }
        });
    }
  }

  joinSession(session: CoachSessionModel) {
    if (session.status === 'confirmed') {
      this.nav.navigate(["/videochat/room/" + session.id]);
    }
  }

  animateInvalidFields() {
    this.animationState = false;
    setTimeout(() => {
      this.animationState = true;
    }, 1);
  }

  joinSessionButtonActive(item) {
    if (new Date(item.start_at).getTime() - 10*60*1000 <= new Date().getTime()) {
      if (new Date().getTime() <= new Date(item.end_at).getTime()) {
        return true
      }
    }
    return false
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((i) => i.unsubscribe());
  }

  getTitleByCode(code: string) {
      const entry = this.availableTypes.find(item => item.code === code);
      if (entry) {
          return entry.title;
      }
      return code;
  }
}
